import { Document } from '@contentful/rich-text-types';
import { ContentImage, ContentMedia, Deserializable, JsonObject } from '@ktypes/models';

export class DialogueInformation implements Deserializable<JsonObject, DialogueInformation> {
  constructor(
    public headerMedia?: ContentImage,
    public header?: string,
    public body?: Document,
    public buttonText?: string,
    public media?: ContentMedia
  ) {}

  deserialize(input: JsonObject): DialogueInformation {
    if (input == null) {
      return null;
    }

    this.headerMedia = new ContentImage().deserialize(input['headerMedia']);
    this.header = input['header'];
    this.body = input['body'];
    this.buttonText = input['buttonText'];
    this.media = new ContentMedia().deserialize(input['mediaElement']);

    return this;
  }
}
